module.exports = __webpack_public_path__ + "img/Group 1140two.0c5dd719.png";